import api from './index';

export const apiGetMessages = async (chat_id) => {
  try {
    const { data } = await api.get(`/chat/${chat_id}/message`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiSendMessage = async (chat_id, message) => {
  try {
    const { data } = await api.post(`/chat/${chat_id}/message`, { message });
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiReadMessages = async (arrMessagesId) => {
  try {
    const { data } = await api.put('/chat/messages/isread', { arrMessagesId });
    return data;
  } catch (error) {
    throw error;
  }
};
